
import {
  AxiosClient,
  AxiosClientServerNuxt,
  AxiosServer,
} from "../../utils/axios";
import { logError } from "../../utils/logError";

export default {
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      listSchool: [],
      loading: false,
      mediaUrl: this.$config.BASE_URL_RESOURCE,
    };
  },
  async fetch() {
    this.loading = true;
    try {
      const domain = this.$config.BASE_URL_CLIENT;
      console.log("Line 27", domain);
      const isOnServer = process.server;
      let res;
      if (isOnServer) {
        console.log("Line 31");
        res = await AxiosClientServerNuxt.get(`/api/school/your-school`, {});
      } else {
        if (window.location.href.includes("/eduzonelocal")) {
          console.log("Line 36");
          res = await AxiosClient.get(`/api/school/your-school`, {});
        } else {
          console.log("Line 40");
          res = await AxiosServer.get(`/api/school/your-school`, {});
        }
      }
      // await this.$store.dispatch('ListSchool/getListYourSchool')

      if (res.data?.length > 4) {
        this.listSchool = res.data.slice(0, 4);
      } else {
        this.listSchool = res.data;
      }
    } catch (e) {
      logError(e, "fetch top school on client");
      this.listSchool = [];
    }
    this.loading = false;
  },
};
